export default {
    props: {
        monthContent: {
            type: String,
            kComposite: 'month.content'
        }, 
        monthWeekNumber: {
            type: String,
            kComposite: 'month.weekNumber'
        }, 
        monthEmpty: {
            type: String,
            kComposite: 'month.empty'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-dateinputs-vue-wrapper/src/KendoDateRangePicker/Month.js